module.exports = __webpack_public_path__ + "img/chat.745f13fa.svg";